import { render, staticRenderFns } from "./SceneMeta.vue?vue&type=template&id=b361ffa4"
import script from "./SceneMeta.vue?vue&type=script&lang=js"
export * from "./SceneMeta.vue?vue&type=script&lang=js"
import style0 from "./SceneMeta.vue?vue&type=style&index=0&id=b361ffa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports